import React, { useState, useEffect } from 'react'
import Drawer from 'components/Drawer'
import RangeSliderInput from 'components/RangeSliderInput'
import Label from 'components/Form/Label'
import Flex from 'components/Flex'
import styled from 'styled-components'
import Button from 'components/Button'
import { Form } from 'antd'

const FlexWrap = styled(Flex)`
  gap: 30px;
`

const ScoreDrawer = ({
  openScoreDrawer,
  setOpenScoreDrawer,
  marksValue,
  setMarksValue,
  roleFormData,
  setRoleFormData,
  setScoreError,
  singleRoleData,
  isEditingRole,
  isEditRoleOnView,
}) => {
  const [marksForm] = Form.useForm()

  const [tenthValue, setTenthValue] = useState(30)
  const [twelfthValue, setTwelfthValue] = useState(30)
  const [ugMarksValue, setUgMarksValue] = useState(30)
  const [pgMarksValue, setPgMarksValue] = useState(30)

  useEffect(() => {
    if (openScoreDrawer && (isEditingRole || isEditRoleOnView)) {
      marksForm.setFieldsValue({
        tenthScore: marksValue?.tenthValue,
        twelfthScore: marksValue?.twelfthValue,
        UGScore: marksValue?.ugMarksValue,
        PGMarks: marksValue?.pgMarksValue,
      })
    }
  }, [openScoreDrawer])
  const onSubmitFormData = data => {
    setMarksValue({
      tenthValue: data?.tenthScore == '0' ? 30 : data?.tenthScore,
      twelfthValue: data?.twelfthScore == '0' ? 30 : data?.twelfthScore,
      ugMarksValue: data?.UGScore == '0' ? 30 : data?.UGScore,
      pgMarksValue: data?.PGMarks == '0' ? 30 : data?.PGMarks,
    })
    setOpenScoreDrawer(false)

    setRoleFormData({
      ...roleFormData,
      scores: {
        ...roleFormData.scores,
        avg: 0,
        tenth: data?.tenthScore == '0' ? 30 : data?.tenthScore,
        twelfth: data?.twelfthScore == '0' ? 30 : data?.twelfthScore,
        UG: data?.UGScore == '0' ? 30 : data?.UGScore,
        PG: data?.PGMarks == '0' ? 30 : data?.PGMarks,
      },
    })

    setScoreError('')
    marksForm.resetFields()
  }
  const content = () => {
    return (
      <Form
        scrollToFirstError
        onFinish={onSubmitFormData}
        id={'marksForm'}
        form={marksForm}
        layout="vertical"
      >
        <FlexWrap column>
          <div>
            <Label>10th Mark</Label>
            <RangeSliderInput
              min={30}
              inputValue={tenthValue}
              setInputValue={setTenthValue}
              defaultValue={tenthValue}
              sliderName={['tenthScore']}
              inputName={['tenthScore']}
              dependencies={['tenthScore']}
              hasFeedback
              sliderrules={[
                () => ({
                  validator(_, value) {
                    if (
                      isEditRoleOnView &&
                      Number(value) > Number(singleRoleData?.tenthScore)
                    ) {
                      return Promise.reject(
                        new Error(
                          `Must be less than ${singleRoleData?.tenthScore}%`
                        )
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </div>

          <div>
            <Label>12 or Equivalent Mark</Label>
            <RangeSliderInput
              min={30}
              inputValue={twelfthValue}
              setInputValue={setTwelfthValue}
              defaultValue={twelfthValue}
              sliderName={['twelfthScore']}
              inputName={['twelfthScore']}
              dependencies={['twelfthScore']}
              hasFeedback
              sliderrules={[
                () => ({
                  validator(_, value) {
                    if (
                      isEditRoleOnView &&
                      Number(value) > Number(singleRoleData?.twelfthScore)
                    ) {
                      return Promise.reject(
                        new Error(
                          `Must be less than ${singleRoleData?.twelfthScore}%`
                        )
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </div>

          <div>
            <Label>UG Marks</Label>
            <RangeSliderInput
              min={30}
              inputValue={ugMarksValue}
              setInputValue={setUgMarksValue}
              defaultValue={ugMarksValue}
              sliderName={['UGScore']}
              inputName={['UGScore']}
              dependencies={['UGScore']}
              hasFeedback
              sliderrules={[
                () => ({
                  validator(_, value) {
                    if (
                      isEditRoleOnView &&
                      Number(value) > Number(singleRoleData?.UGScore)
                    ) {
                      return Promise.reject(
                        new Error(
                          `Must be less than ${singleRoleData?.UGScore}%`
                        )
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </div>

          <div>
            <Label>PG Marks</Label>
            <RangeSliderInput
              min={30}
              inputValue={pgMarksValue}
              setInputValue={setPgMarksValue}
              defaultValue={pgMarksValue}
              sliderName={['PGMarks']}
              inputName={['PGMarks']}
              dependencies={['PGMarks']}
              hasFeedback
              sliderrules={[
                () => ({
                  validator(_, value) {
                    if (
                      isEditRoleOnView &&
                      Number(value) > Number(singleRoleData?.PGScore)
                    ) {
                      return Promise.reject(
                        new Error(
                          `Must be less than ${singleRoleData?.PGScore}%`
                        )
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </div>
        </FlexWrap>
      </Form>
    )
  }
  const footer = () => {
    return (
      <FlexWrap right>
        <Button.Secondary
          text="Close"
          onClick={() => {
            setOpenScoreDrawer(false)
          }}
        />
        <Button.Primary htmlType="submit" form="marksForm" text={'Confirm'} />
      </FlexWrap>
    )
  }

  return (
    <Drawer
      zIndex="1001"
      width="30%"
      title={'Config Custom Score'}
      placement="right"
      closable={true}
      onClose={() => setOpenScoreDrawer(false)}
      visible={openScoreDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default ScoreDrawer
